import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import { Dropdown, Checkbox } from "semantic-ui-react";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import "./EditConsultant.scss"
import InputMask from "react-input-mask";
import translator from "../../../utils/translator";

export class EditConsultant extends Component {
	state = {
        search_query: "",
        searchTimeout: null,
        user_list: [],
		response: {},
        //------
        id: "",
        name: "",
        address: "",
        city: "",
        province: "",
        postal: "",
        phone: "",
        website: "",
        hours: "",
        warehouses: [],
		emails: [],
		primary_warehouse: 0,
		primary_email: 0,
		new_user: 0
	};

	// ============= AJAX FUNCTIONS =============

	callAjax = async (route, data) => {
		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");

		let APIResponse = await Axios.post(this.props.APIUrl + route, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.setState({ response: { error: APIResponse.data.error } });
			return false;
		}
		this.setState({ response: {} });
		return APIResponse.data;
    };
    
    getUsers = async query => {
        this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
		let route = "/settings/search-users";
		let response = await this.callAjax(route, { q: query });
		if (!response) return;
		if (!response.hasOwnProperty("user_list")) this.setState({ user_list: [] });
		else this.setState({ user_list: response.user_list });
	};
	
	validateSettings = async () => {
		let state = this.state;

		if(!!state.new_user) {
			if(!state.id) {
				return translator("Misc", "supply_trend_id_error");
			} else {
				let response = await this.callAjax("/settings/get-user", { id: state.id });
				if(!!response.user) {
					return translator("Admin Edit Consultant", "duplicate_id");
				}
			}
		}
		if(!state.name) {
			return translator("Misc", "supply_users_name_error");
		}
		if(!state.warehouses.length) {
			return translator("Misc", "primary_warehouse_not_selected");
		}
		if(!state.emails.length) {
			return translator("Misc", "supply_users_email_error");
		}
		return "";
	}

	saveSettings = async () => {
		let error = await this.validateSettings();
		if(error) {
			this.setState({ response: { error: error } });
			return;
		}

        this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });

        let state = this.state;
		let route = "/settings/save-user";
		let data = {
            id:         state.id,
			name:       state.name,
            address_1:  state.address_1,
            city:       state.city,
            province:   state.province,
            postal:     state.postal,
            phone:      state.phone,
            website:    state.website,
            hours:      state.hours,
            warehouses: state.warehouses,
			emails:     state.emails,

			primary_warehouse:	state.primary_warehouse,
			primary_email:		state.primary_email,

			new_user: state.new_user,
			language: this.props.selected_language
		};

		let response = await this.callAjax(route, data);
		if (!response) return;

		if(state.new_user) {
			let record = await this.callAjax("/settings/get-user", { id: state.id });
			this.setUser(record.user);
			this.setState({ user_list: [record.user] });
		}
		this.setState({ response: response });
	};

	// ============= HANDLER FUNCTIONS =============

	searchUsers = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			searchTimeout: window.setTimeout(this.getUsers, 500, query)
		});
	};

	setUser = user => {
		let primary_warehouse = user.warehouses.reduce(
			(prime, warehouse, i) => warehouse.primary ? i : prime,
			0
		);
		let primary_email = user.emails.reduce(
			(prime, email, i) => email.primary ? i : prime,
			0
		);
		this.setState({ 
            id:         user.id,
			name:       user.name,
            address_1:  user.address_1,
            city:       user.city,
            province:   user.province,
            postal:     user.postal,
            phone:      user.phone,
            website:    user.website,
            hours:      user.hours,
            warehouses: user.warehouses,
			emails:     user.emails,
			new_user:	0,
			//
			primary_warehouse:	primary_warehouse,
			primary_email:		primary_email
        });
	};

	setNewUser = () => {
		this.setState({ 
			search_query: "",
			user_list: [],
			//
            id: "",
			name: "",
			address_1: "",
			city: "",
			province: "",
			postal: "",
			phone: "",
			website: "",
			hours: "",
			warehouses: [],
			emails: [],
			primary_warehouse: 0,
			primary_email: 0,
			new_user: 1
		});
	}

	setField = (field, event) => {
		this.setState({ 
            [field]: event.target.value
        });
	}

	// ============= RENDER FUNCTIONS =============

	renderUser = state => {
		let user_dictionary = state.user_list.reduce((obj, user) => ({...obj, [user.id]: user}), {});
		let user_options = state.user_list.map(user => ({ value: user.id, text: (<div className="users_dropdown"><span>{user.id}</span>{" - " + user.name}</div>) }));

		return (
			<div class="card user-profile-card mb1">
				<div class="card-body">
					<div className="search-wrapper">
						<Dropdown
							fluid
							search={(options, query) => options}
							selection
							placeholder={translator("Admin Edit Consultant", "search_placeholder")}
							options={user_options}
							value={state.id}
							onSearchChange={(e, d) => {
								this.searchUsers(d.searchQuery);
							}}
							onChange={(e, d) => this.setUser(user_dictionary[d.value])}
						/>
						<button 
							class="btn btn-primary new_user_btn"
							onClick={this.setNewUser}
						>
							{translator("Admin Edit Consultant", "new_btn")}
						</button>
					</div>
				</div>
			</div>
		);
	};

	renderSettings = state => {
		let provinces = [
			{value: "AB", text: "Alberta"},
			{value: "BC", text: "British Columbia"},
			{value: "MB", text: "Manitoba"},
			{value: "NB", text: "New Brunswick"},
			{value: "NL", text: "Newfoundland and Labrador"},
			{value: "NT", text: "Northwest Territories"},
			{value: "NS", text: "Nova Scotia"},
			{value: "NU", text: "Nunavut"},
			{value: "ON", text: "Ontario"},
			{value: "PE", text: "Prince Edward Island"},
			{value: "QC", text: "Quebec"},
			{value: "SK", text: "Saskatchewan"},
			{value: "YT", text: "Yukon Territory"},
		];
		provinces = provinces.map(prov => ({ ...prov, text: (<div className="users_dropdown">{prov.text}</div>) }));
		return (
			<div class="card user-profile-card">
				<div class="card-body">
                    <table className="settings-table">
						<tbody>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "trend_label")}</td>
								<td>
								<input 
									type="text"
									className="form-control"
									value={state.id}
									onChange={e => state.new_user ? this.setField("id", e) : null}
									disabled={!state.new_user}
								/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "name_label")}</td>
								<td>
									<input 
										type="text"
										className="form-control"
										value={state.name}
										onChange={e => this.setField("name", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "address_label")}</td>
								<td>
									<input 
										type="text"
										className="form-control"
										value={state.address_1}
										onChange={e => this.setField("address_1", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "city_label")}</td>
								<td>
									<input 
										type="text"
										className="form-control"
										value={state.city}
										onChange={e => this.setField("city", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "province_label")}</td>
								<td>
									<Dropdown
										fluid
										selection
										options={provinces}
										value={state.province}
										onChange={(e, data) => this.setField("province", {target: data})}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "postal_label")}</td>
								<td>
									<InputMask 
										mask="a9a 9a9"
										className="form-control"
										value={state.postal}
										onChange={e => this.setField("postal", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "phone_label")}</td>
								<td>
									<InputMask 
										mask="999-999-9999"
										className="form-control"
										value={state.phone}
										onChange={e => this.setField("phone", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "website_label")}</td>
								<td>
									<input 
										type="text"
										className="form-control"
										value={state.website}
										onChange={e => this.setField("website", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "hours_label")}</td>
								<td>
									<input 
										type="text"
										className="form-control"
										value={state.hours}
										onChange={e => this.setField("hours", e)}
									/>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "warehouses_label")}</td>
								<td>
									<table class="warehouse-table">
										<tbody>
											{state.warehouses.map((warehouse, i) => (
												<tr key={i}>
													<td>
														<input 
															type="text"
															className="form-control"
															value={warehouse.id}
															onChange={e => this.setState({ 
																warehouses: state.warehouses.map(
																	(w, index) => index === i ? {...w, id: e.target.value} : w
																) 
															})}
														/>
													</td>
													<td>
														<Checkbox 
															radio
															label="Primary"
															name='primary_warehouse'
															value={i}
															checked={i === state.primary_warehouse}
															onChange={(e, data) => this.setField("primary_warehouse", {target: data})}
														/>
													</td>
													<td>
														<button
															className="btn btn-primary"
															onClick={() => {
																if(i === state.primary_warehouse) {
																	this.setState({ primary_warehouse: 0 })
																}
																this.setState({ warehouses: state.warehouses.filter((w, index) => index !== i) })
															}}
														>
															{translator("Misc", "delete_label")}
														</button>
													</td>
												</tr>
											))}
											<tr>
												<td>
													<button
														className="btn btn-primary add-new"
														onClick={() => this.setState({ warehouses: [...state.warehouses, { id: "", primary: 0 }] })}
													>
														{translator("Admin Edit Consultant", "new_warehouse_btn")}
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td className="td-label">{translator("Admin Edit Consultant", "email_label")}</td>
								<td>
									<table class="email-table">
										<tbody>
											{state.emails.map((email, i) => (
												<tr key={i}>
													<td>
														<input 
															type="text"
															className="form-control"
															value={email.email}
															onChange={e => this.setState({ 
																emails: state.emails.map(
																	(m, index) => index === i ? {...m, email: e.target.value} : m
																) 
															})}
														/>
													</td>
													<td>
														<Checkbox 
															radio
															label="Primary"
															name='primary_email'
															value={i}
															checked={i === state.primary_email}
															onChange={(e, data) => this.setField("primary_email", {target: data})}
														/>
													</td>
													<td>
														<button
															className="btn btn-primary"
															onClick={() => {
																if(i === state.primary_email) {
																	this.setState({ primary_email: 0 })
																}
																this.setState({ emails: state.emails.filter((w, index) => index !== i) })
															}}
														>
															{translator("Misc", "delete_label")}
														</button>
													</td>
												</tr>
											))}
											<tr>
												<td>
													<button
														className="btn btn-primary add-new"
														onClick={() => this.setState({ emails: [...state.emails, { email: "", primary: 0 }] })}
													>
														{translator("Admin Edit Consultant", "new_email_btn")}
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>

					<button type="button" class="btn btn-primary pbook-settings-submit" onClick={() => this.saveSettings()}>
						{translator("Admin Picturebook", "submit_btn")}
					</button>
				</div>
			</div>
		);
	};

	renderResponse = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	render() {
		let state = this.state;
		let main = (
			<>
				{this.renderUser(state)}
				{state.id || state.new_user ? this.renderSettings(state) : null}
				{Object.keys(state.response).length ? this.renderResponse(state.response) : null}
			</>
		);
		return (
			<SettingsWrapper header={translator("Admin Edit Consultant", "page_title")} main={main} classes="edit-user-settings"/>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EditConsultant);
